import { Ticker } from "@fartherfinance/frontend/api/Types";

import {
  BasePermissionOptionType,
  EntityOption,
  TaxTypeOption,
} from "./reducer/Types";

export const taxTypeOptions: TaxTypeOption[] = [
  {
    id: "any",
    label: "Any",
  },
  {
    id: "taxable",
    label: "Taxable",
  },
  {
    id: "tax_exempt",
    label: "Tax-advantaged",
  },
  {
    id: "DirectIndexedSleeve",
    label: "Direct Indexed Sleeve",
  },
] as const;

export const taxStatusIdToLabel = {
  any: "Any",
  taxable: "Taxable",
  tax_exempt: "Tax-advantaged",
  DirectIndexedSleeve: "Direct Indexed Sleeve",
} as const;

export const EntityOptions: EntityOption[] = [
  {
    label: "Asset Classes",
    id: "Asset Classes",
  },
  {
    label: "Sleeves",
    id: "Sleeves",
  },
  {
    label: "Securities",
    id: "Securities",
  },
] as const;

export const basePermissionOptions: BasePermissionOptionType[] = [
  {
    label: "Public-Organization",
    id: "Public-Organization",
  },
  {
    label: "Public-Platform",
    id: "Public-Platform",
  },
  {
    label: "Private",
    id: "Private",
  },
] as const;

export const taxMapping = {
  any: [],
  taxable: ["Taxable" as const],
  tax_exempt: ["TaxExempt" as const],
  DirectIndexedSleeve: ["DirectIndexedSleeve" as const],
};

export const TEMPORARY_TICKER = "--" as Ticker;
